import * as cart from "@shopify/theme-cart";
import * as currency from "@shopify/theme-currency";
import { ApplicationController } from "stimulus-use";

export default class extends ApplicationController {
  static targets = ["list"];

  get template() {
    return this.element.querySelector("template");
  }

  connect() {
    this.refresh();
  }

  async refresh() {
    const cartState = await cart.getState();

    // Clears list
    const newItemNodes = await Promise.all(
      cartState.items.map((item) => this.createItem(item))
    );
    this.listTarget.innerHTML = "";
    newItemNodes.forEach((itemNode) => {
      this.listTarget.appendChild(itemNode);
    });

    const cartTotalPrice = this.element.querySelector(".cart__total_price");
    if (cartTotalPrice) {
      cartTotalPrice.textContent = currency
        .formatMoney(cartState.total_price)
        // TODO: temporary hack
        .replace("$", "RM");
    }

    const cartSubmit = this.element.querySelector(".cart__checkout");
    if (cartSubmit) {
      cartSubmit.toggleAttribute("disabled", cartState.items.length === 0);
    }

    this.dispatch("refreshed", cartState);
  }

  async createItem(item) {
    if (!this.template) {
      throw Error("No template found");
    }
    const itemNode = document.importNode(this.template.content, true);
    const itemIndex = await cart.getItemIndex(item.key);

    const itemWrapper = itemNode.querySelector(".cart-item__wrapper");
    if (itemWrapper) {
      itemWrapper.dataset.cartItemKeyValue = item.key;
      itemWrapper.dataset.cartItemLineValue = itemIndex;
    }

    const itemImage = itemNode.querySelector(".cart-item__image");
    if (itemImage) {
      itemImage.setAttribute("src", item.featured_image.url);
      itemImage.setAttribute("alt", item.featured_image.alt);
    }

    const itemTitle = itemNode.querySelector(".cart-item__name");
    if (itemTitle) {
      itemTitle.setAttribute("href", item.url);
      itemTitle.textContent = item.title;
    }

    const itemRemove = itemNode.querySelector(".cart-item__remove");
    if (itemRemove) {
      itemRemove.setAttribute("id", `Remove-${itemIndex}`);
      itemRemove.dataset.index = itemIndex;

      const removeLink = itemRemove.querySelector(".remove-icon");
      if (removeLink) {
        removeLink.setAttribute(
          "href",
          `${routes.cart_change_url}?id=${item.key}&quantity=0`
        );
      }
    }

    const itemQuantity = itemNode.querySelector(".quantity__input");
    if (itemQuantity) {
      itemQuantity.value = item.quantity;
    }

    const itemPrice = itemNode.querySelector(".cart-item__price");
    if (itemPrice) {
      itemPrice.textContent = currency
        .formatMoney(item.final_line_price)
        // TODO: temporary hack
        .replace("$", "RM");
    }

    return itemNode;
  }
}
